import { createSelector } from 'reselect';
const boxNotecardEditorRootSelector = state => state.boxNotecardEditor;
export const stepSelector = createSelector(boxNotecardEditorRootSelector, state => state.step);
export const selectedBoxItemsIdSelector = createSelector(boxNotecardEditorRootSelector, state => state.boxItemsId);
export const isLoadingSelector = createSelector(boxNotecardEditorRootSelector, state => state.loading);